import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Grid, makeStyles, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import brandTheme from "brandTheme/Theme";
import PersonalInfoReview from "./PersonalInfoReview";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import IncomeDetailsReview from "./IncomeDetails";
import ReferenceReview from "./ReferenceDetails";
import LoanDetailsReview from "./LoanDetails";
import RepaymentDetails from "./RepaymentDetails";
import AddressDetails from "./AddressDetails";
import BankDetails from "./BankDetails";
import DocumentReview from "./DocumentReview";
import MandateDetails from "./MandateDetails";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";

const useStyles = makeStyles(styles);
const style = (theme) => ({
  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "0 5px 0 0 ",
    letterSpacing: "1px",
    height: "40px",
    backgroundColor: brandTheme.buttonColor,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
});

const PersonalLoanReview = () => {
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();
  const [incomeDetails, setIncomeDetails] = useState({});
  const [generalDetails, setGeneralDetails] = useState({});
  const [referenceDetails, setReferenceDetails] = useState({});
  const [loanDetails, setLoanDetails] = useState({});
  const [documentDetails, setDocumentDetails] = useState({});
  const [repaymentDetails, setRepaymentDetails] = useState({});
  const [userLeadIdDetails, setUserLeadIdDetails] = useState({});
  const [addressDetails, setAddressDetails] = useState({});
  const [bankDetails, setBankDetails] = useState({});
  const [adhaarDetails, setAdhaarDetails] = useState({});
  const [photoDetails, setPhtotDetails] = useState({});
  const [mandateDetails, setMandateDetails] = useState({});
  const [eligibleAmountDetails, setEligibleAmountDetails] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  useEffect(() => {
    getIncomeDetails();
  }, [params]);

  const getIncomeDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_ALL_LEAD_DETAILS + params?.loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setIncomeDetails(result?.data?.incomeDetail);
      setGeneralDetails(result?.data?.applicantDetail);
      setReferenceDetails(result?.data?.leadRefferal);
      setLoanDetails(result?.data?.leadLoanDetail);
      setDocumentDetails(result?.data?.leadDocumentDetail);
      setRepaymentDetails(result?.data?.leadReaymentDetail);
      setUserLeadIdDetails(result?.data?.leadApplication);
      setAddressDetails(result?.data?.applicantAddress);
      setBankDetails(result?.data?.applicantBankDetail);
      setAdhaarDetails(result?.data?.aadharDetails);
      setPhtotDetails(result?.data?.photoDetails);
      setMandateDetails(result?.data?.mandateDetails);
      setEligibleAmountDetails(
        result?.data?.leadApplication?.max_eligible_loan_amount
      );
    }
  };
  const handlecreateuserSubmit = async () => {
    // setNext();
  };
  return (
    <Grid container style={{maxWidth:'1600px', textAlign:'center', margin:'0 auto'}}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="REVIEW SCREEN" />
      </Grid>
      <GridContainer
        style={{ margin: "0 auto", width: "100%", textAlign: "left" }}
      >
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {generalDetails && (
            <>
              <PersonalInfoReview
                classes={classes}
                documentDetails={documentDetails}
                generalDetails={generalDetails}
                userLeadIdDetails={userLeadIdDetails}
                photoDetails={photoDetails}
              />
            </>
          )}
          {incomeDetails && (
            <>
              <IncomeDetailsReview
                classes={classes}
                incomeDetails={incomeDetails}
                userLeadIdDetails={userLeadIdDetails}
                adhaarDetails={adhaarDetails}
              />

            </>
          )}
          {loanDetails && (
            <>
              <LoanDetailsReview
                classes={classes}
                loanDetails={loanDetails}
                eligibleAmountDetails={eligibleAmountDetails}
              />

            </>
          )}
          {repaymentDetails && (
            <>
              <RepaymentDetails
                classes={classes}
                repaymentDetails={repaymentDetails}
              />

            </>
          )}
          {referenceDetails && referenceDetails?.length > 0 && (
            <>
              <ReferenceReview
                classes={classes}
                referenceDetails={referenceDetails}
              />

            </>
          )}
          {addressDetails && addressDetails?.length > 0 && (
            <>
              <AddressDetails
                classes={classes}
                addressDetails={addressDetails}
              />

            </>
          )}
          {bankDetails && (
            <>
              <BankDetails classes={classes} bankDetails={bankDetails} />

            </>
          )}
          {documentDetails?.sanctionletter && (
            <>
              <DocumentReview
                classes={classes}
                documentDetails={documentDetails}
              />

            </>
          )}
          {mandateDetails?.mandateId && (
            <>
              <MandateDetails
                classes={classes}
                mandateDetails={mandateDetails}
              />

            </>
          )}

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={() => navigate("/loanservice/PersonalLoan", { state: { from: '' } })}
              >
                Cancel
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

PersonalLoanReview.propTypes = {
  classes: PropTypes.object,
  loanApplicationId: PropTypes.object,
};

export default withStyles(style)(PersonalLoanReview);
